import React from 'react'
import { Modal, Button } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import './styles.scss'
const ModalGuideInvoice = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={[
        <Button type="primary" onClick={onClose}>
          Đóng
        </Button>,
      ]}
      width={720}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <InfoCircleOutlined style={{ color: '#1677ff' }} />
          <span>Hướng dẫn lập hóa đơn kèm theo bảng kê hàng hóa, dịch vụ</span>
        </div>
      }
    >
      {/* Block 1 */}
      <div className="guide-block">
        <div className="guide-title">
          Sử dụng bảng kê kèm theo hóa đơn đối với các trường hợp sau:
        </div>

        <ul>
          <li>
            <b>Lập hóa đơn theo kỳ quy ước (tháng, quý):</b> Áp dụng cho các
            loại hàng hóa, dịch vụ đặc thù như điện, nước, viễn thông, công nghệ
            thông tin, truyền hình, bưu chính, ngân hàng, chứng khoán, bảo hiểm.
          </li>

          <li>
            <b>Lập hóa đơn sau khi đối soát dữ liệu:</b> Áp dụng cho dịch vụ
            khám bệnh, chữa bệnh; Các trường hợp khác theo hướng dẫn của Bộ Tài
            chính.
          </li>

          <li>
            <b>Lập hóa đơn khuyến mại</b> hàng hóa, dịch vụ theo quy định của
            pháp luật về thương mại; <b>cho, biếu, tặng</b> hàng hóa, dịch vụ.
          </li>
        </ul>
      </div>

      {/* Divider */}
      <div className="guide-divider" />

      {/* Block 2 */}
      <div className="guide-block">
        <div className="guide-title">Quy định đối với hóa đơn:</div>

        <ul>
          <li>
            Hóa đơn phải ghi rõ “Kèm theo bảng kê số..., ngày... tháng...
            năm...”.
          </li>
        </ul>
      </div>

      {/* Divider */}
      <div className="guide-divider" />

      {/* Block 3 */}
      <div className="guide-block">
        <div className="guide-title">Quy định đối với bảng kê:</div>

        <ul>
          <li>
            Bảng kê phải có tên, mã số thuế và địa chỉ của người bán, tên hàng
            hóa, dịch vụ, số lượng, đơn giá, thành tiền hàng hóa, dịch vụ bán
            ra, ngày lập, tên và chữ ký người lập bảng kê...
          </li>

          <li>
            Bảng kê phải ghi rõ “Kèm theo hóa đơn số... ngày... tháng...
            năm...”.
          </li>
        </ul>
      </div>
    </Modal>
  )
}

export default ModalGuideInvoice
